var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm._globalComponents),function(component){return _c('v-checkbox',{key:'globalComponentCheckbox'+component,attrs:{"value":component,"label":component},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }